const service = [
    {
        path: '/service/package',
        name: 'servicePackage',
        component: () => import('@/view/service/package'),
    },
    {
        path: '/service/show',
        name: 'serviceShow',
        component: () => import('@/view/service/show'),
    },
    {
        path: '/service/record',
        name: 'serviceRecord',
        component: () => import('@/view/service/record'),
    },
    
]
export default service